import { createContext, useContext } from 'react';

const PrintContext = /*#__PURE__*/createContext(false);
function useIsBeingPrinted() {
  return useContext(PrintContext);
}

export { PrintContext, useIsBeingPrinted };
//# sourceMappingURL=context.print.js.map
